import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import AnnouncementIndividualPage from './AnnouncementIndividualPage';

const AnnouncementIndividualPageWrapper = () => {
  const navigate = useNavigate();
  const { announcementId } = useParams();

  return (
    <AnnouncementIndividualPage 
      navigate={navigate}
      announcementId={announcementId}
    />
  );
};

export default AnnouncementIndividualPageWrapper;
